// hooks/useFetchAllUserLineups.js
import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const fetchAllUserLineups = async (
  leagueId,
  userId,
  getAccessTokenSilently,
) => {
  const token = await getAccessTokenSilently();
  const apiUrl = process.env.REACT_APP_API_URL;

  const { data } = await axios.get(
    `${apiUrl}/api/lineup/user/${userId}/league/${leagueId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  // The endpoint returns { success, userId, leagueId, count, submissions }
  // We want to return just the submissions array
  return data.submissions || [];
};

export const useFetchAllUserLineups = (leagueId, userId) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery(
    ["allUserLineups", leagueId, userId],
    () => fetchAllUserLineups(leagueId, userId, getAccessTokenSilently),
    {
      enabled: !!leagueId && !!userId,
      onError: (error) => {
        console.error("Error fetching all user lineups:", error);
        console.error(
          "Endpoint:",
          `/api/lineup/user/${userId}/league/${leagueId}`,
        );
        if (error.response?.status === 404) {
          console.error(
            "❌ Backend endpoint does not exist. See BACKEND_ENDPOINT_NEEDED.md",
          );
        }
      },
    },
  );
};
